import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SearchService } from "../search.service";
import { Global } from "../classes/Global";
import { InfiniteScrollComponent } from "../classes/InfiniteScrollComponent";
import { Location } from "@angular/common";
import { Cache } from '../classes/Cache';
import { ScrollHelper } from '../helpers/ScrollHelper';
import { InfoService } from '../info.service';
import { StorageHelper } from '../helpers/StorageHelper';
import { Log } from '../helpers/Log';
import { WishlistService } from '../wishlist.service';
import { Config } from '../classes/Config';
import { BlocklistService } from '../blocklist.service';
import { OwnListService } from '../own-list.service';
import { ListHelper } from '../helpers/ListHelper';
import { AiStructuredDataHelper } from '../helpers/AiStructuredDataHelper';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [ SearchService, InfoService, WishlistService, BlocklistService, OwnListService ]
})
export class SearchComponent extends InfiniteScrollComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('searchBar', {static: false}) searchBar;
  @ViewChild("header", {static: false}) header;

  defaultLimit = 10;
  moreResultsLimit = 24;
  query: string;
  searchResults;
  medias: Array<any>;
  selectedItemType = "all";
  selectedItemTypeFromUrl = "";
  noMatch = false;
  showSpinner = false;
  searchHistory: Array<string> = [];
  routeParamsSubscription;
  itemTypes: Array<string> = [];
  mediaTypesForSelector: Array<string> = [];
  availableMediaTypes: Array<string> = [];
  selectedMedia = "";
  schema;

  // by default, the new search will be used (getSuggestions)
  searchMode = 'v1';//'v2';

  constructor(
    private route: ActivatedRoute,
    private searchService: SearchService,
    private router: Router,
    private location: Location,
    private wishlistService: WishlistService,
    private ownlistService: OwnListService,
    private blocklistService: BlocklistService
  ) {
    super();
    this.limit = this.defaultLimit; //this does not work on the server side. The limit has no effect
    this.initItemTypes();
    this.initMediaTypesForSelector();
    this.initAvailableMediaTypes();
    this.selectedItemType = StorageHelper.getInstance().get(StorageHelper.keys.searchItemType) || "all";
  }

  ngOnInit() {

    this.buildGptApiSchema();

    this.routeParamsSubscription = this.route.params.subscribe(params => {

        this.query = params['q'];
        if (params['t']){
          this.selectedItemType = params['t'];
          this.selectedItemTypeFromUrl = params['t']; //used for display logic of media selector
        }

        if (this.query){
          this.query = decodeURIComponent(this.query);

          if (!this.loadItemsFromCache()) {
            this.loadItems();
          }

        }
        else {
          this.query = "";
        }
      }

    );
  }

  ngAfterViewInit() {
    this.setScrollPosition();
  }

  ngOnDestroy() {
    this.routeParamsSubscription.unsubscribe();
  }

  initItemTypes() {
    this.itemTypes = Global.mediaTypesForSearch[Global.getStore()];
    //If the new store does not have the currenty selected one, pick the first available
    if (this.itemTypes && this.itemTypes instanceof Array && this.itemTypes.length > 0) {
      if (this.itemTypes.indexOf(this.selectedItemType) === -1) {
        this.selectedItemType = this.itemTypes[0];
      }
    }
  }

  initMediaTypesForSelector(medias?: Array<string>) {
    if (medias && medias.length > 0) {
      this.mediaTypesForSelector = medias;
    }
    else {
      this.mediaTypesForSelector = Global.mediaTypesForSearchSelector[Global.getStore()];
    }
  }

  initAvailableMediaTypes(medias?: Array<string>) {
    if (medias) {
      this.availableMediaTypes = medias;
    }
    else {
      this.availableMediaTypes = Global.mediaTypesForSearchSelector[Global.getStore()];
    }
  }

  loadItems() {
    this.offset = 0;
    this.showSpinner = true;
    this.noMatch = false;
    this.resultsEndReached = false;
    this.previousScrollY = -1;
    this.searchResults = null;
    this.medias = [];

    this.searchForItems().subscribe(res => {
      if (res) {
        if (res["results"]) {

          if(this.searchMode == "v2") {
            this.searchResults = res["results"]["results"];
            this.medias = [...new Set((this.searchResults as Array<any>).map(x => x.mediaType))];
          }
          else {
            this.searchResults = res["results"];
            this.medias = Object.keys(this.searchResults);
          }

          if (this.medias && this.medias.length > 0) {
            this.selectedMedia = this.medias[0];
            this.addToCache({ items: this.searchResults, offset: this.offset });
          }
          this.initAvailableMediaTypes(this.medias);
          if (Object.keys(this.searchResults).length == 0) {

            if(this.searchMode == "v2") {
              // if v2 returns no results, try with v1
              this.searchMode = "v1";
              this.loadItems();
              return;
            }
            else {
              this.noMatch = true;
            }

          }

          // filter out items that appear in the blocklist
          const shortBlocklist = StorageHelper.getInstance().get(StorageHelper.keys.shortBlocklist)||{};
          if(shortBlocklist[Global.getStore()]) {

            for(let med of this.medias) {
              let mediaForBlocklist = med;
              if(mediaForBlocklist == "seasons") {mediaForBlocklist = "tv";}
              if(mediaForBlocklist == "albums") {mediaForBlocklist = "music";}
              if(mediaForBlocklist == "singles") {mediaForBlocklist = "music";}

              // Use optimized Set-based filtering
              if (this.searchMode == "v2") {
                this.searchResults = ListHelper.filterItemsByBlocklist(this.searchResults, Global.getStore(), mediaForBlocklist);
              }
              else {
                if (this.searchResults[med]) {
                  this.searchResults[med] = ListHelper.filterItemsByBlocklist(this.searchResults[med], Global.getStore(), mediaForBlocklist);
                }
              }
            }

          }

          // show end of results
          if(this.searchMode == "v2") {
            if (this.selectedItemType && this.selectedItemType != "all" &&
            this.searchResults && this.searchResults.length < this.limit) {
              this.resultsEndReached = true;
            }
          }
          else {
            if (this.selectedItemType && this.selectedItemType != "all" &&
            this.searchResults[this.selectedItemType] && this.searchResults[this.selectedItemType].length < this.limit) {
              this.resultsEndReached = true;
            }
          }

        }
        else {
          this.initAvailableMediaTypes([]);
          this.noMatch = true;
        }

        let status = "";
        let message = "";
        if(this.searchMode == "v2") {
          message = res["results"]["message"];
          status = res["results"]["status"];
        }
        else {
          message = res["message"];
          status = res["status"];
        }

        if(message == "no data" || status == "error") {
          this.noMatch = true;
          this.initAvailableMediaTypes([]);
        }
      }
      this.showSpinner = false;
      window.scrollTo(0, 0);
    }, err => {
      Log.getInstance().d(err);
    });

  }

  searchForItems(){

    if (this.selectedItemType == "all"){ this.limit = this.defaultLimit; }

    if(this.searchMode == "v2") {
      return this.searchService.getSuggestions(Global.getStore(),
      this.selectedItemType, Global.getCountry(), this.query, this.offset, this.limit);
    }
    else {
      return this.searchService.searchForItems(Global.getStore(),
      this.selectedItemType, Global.getCountry(), this.query, this.offset, this.limit);
    }

  }

  loadMoreItems(){
    if (this.selectedItemType != "all"){
      this.showSpinner = true;
      this.isLoading = true;
      this.offset += this.limit;
      this.searchForItems().subscribe(res => {

        if (this.searchResults && res["results"]) {

          const newItems = res["results"][this.selectedItemType];
          if (newItems && newItems.length > 0) {
            if(!this.searchResults[this.selectedItemType]) {
              this.searchResults[this.selectedItemType] = [];
            }
            this.searchResults[this.selectedItemType] = this.searchResults[this.selectedItemType]
            .concat(newItems);
            this.addToCache({ items: this.searchResults, offset: this.offset });
          }
          if (!newItems || newItems.length == 0) {
            this.resultsEndReached = true; //Avoid trying to load further items
          }
          this.isLoading = false;
          this.showSpinner = false;
        }

      }, err => {
        Log.getInstance().d(err);
      });
    }
  }

  searchClicked(obj){
    if (obj.query  && obj.query != ""){
      if (obj.query == this.query && obj.itemType == this.selectedItemType){
        //Clicked again with no changes, force reload the data
        this.loadItems();
      }
      this.router.navigate([ "/" + this.getCountry() + "/search", { q: encodeURIComponent(obj.query), t: obj.itemType}]);
    }
  }

  moreResultsClicked(media){

    //save the search in the history
    this.searchHistory.push(JSON.stringify({q: this.query, t: this.selectedItemType}));

    this.limit = this.moreResultsLimit;
    this.router.navigate([ "/" + this.getCountry() + "/search", { q: encodeURIComponent(this.query), t: media}]);
  }

  itemClicked(){

    //Save scroll position
    const cache = Cache.getInstance();
    cache.saveScrollPosition(this.router.url, window.scrollY);

  }

  storeChanged() {
    //Update itemTypes
    this.initItemTypes();
    this.initMediaTypesForSelector();
    this.initAvailableMediaTypes();

    //If the new store does not have the currenty selected one, pick the first available
    if (this.itemTypes.indexOf(this.selectedItemType) === -1){
      this.selectedItemType = this.itemTypes[0];
    }

    this.searchBar.itemTypeChanged(this.selectedItemType);
    this.buildGptApiSchema();

    if (this.query){
      this.loadItems();
    }
  }

  buildGptApiSchema() {
    this.schema = AiStructuredDataHelper.buildSearchPageSchema(Global.getCountry(), Global.getStore());
  }

  mediaChanged(media) {

    if (media){
      this.selectedMedia = media;

      //Scroll down to selected media
      const mediaSectionElement = document.getElementById(media + "_section");
      ScrollHelper.smoothScroll(mediaSectionElement);
    }
  }

  shouldDisplayMoreResults(media: string): boolean {
    if (this.searchResults[media]) {
      return this.searchResults[media].length >= this.limit;
    }
    return false;
  }

  back() {
    this.location.back();
  }

  setScrollPosition() {
    const cache = Cache.getInstance();
    const scrollPos = cache.getScrollPosition(this.router.url);
    cache.deleteScrollPosition(this.router.url); //To ensure that it is only used one time
    if (scrollPos) {
      window.scrollTo(0, scrollPos); //x, y
    }
  }

  addToCache(data: any){
    const cache = Cache.getInstance();
    const url = this.router.url + "_" + Global.getCountry();
    cache.addData(url, data);
  }

  loadItemsFromCache(url?: string): boolean {
    const cache = Cache.getInstance();
    if (!url) { url = this.router.url + "_" + Global.getCountry(); }
    const data = cache.getData(url);
    if (data){
      this.searchResults = data["items"];
      this.medias = Object.keys(this.searchResults);
      this.selectedMedia = this.medias[0];
      this.initAvailableMediaTypes(this.medias);
      this.offset = data["offset"];
      return true;
    }

    return false;
  }

  addToWishlist(item, media) {
    const id = item.idInStore || item.itemID;
    const itemType = Global.getItemTypeForWishList(media);
    const ignoreSdPrice = this.shouldIgnoreSdPriceForMediaType(itemType);
    this.wishlistService.addItem(Global.getCountry(), Global.getStore(), itemType,
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id, ignoreSdPrice).subscribe(res => {
      this.getShortWishlist();
    }, res => {

    });
  }

  /**
   * Checks if SD price should be ignored when adding to wishlist.
   * Only applies to movies and TV seasons.
   */
  private shouldIgnoreSdPriceForMediaType(mediaType: string): boolean {
    const setting = StorageHelper.getInstance().get(StorageHelper.keys.ignoreSdPriceOnWishlist);
    // Default is true - only return false if explicitly set to false
    if (setting === false) {
      return false;
    }
    // Only apply to movies and TV seasons
    // Note: 'seasons' is the plural of 'season' itemType, 'tvSeasons' is the plural of 'tvSeason' itemType
    const movieAndTvTypes = ['movies', 'buyMovies', 'rentalMovies', 'seasons', 'tvSeasons'];
    return movieAndTvTypes.indexOf(mediaType) !== -1;
  }

  removeFromWishlist(item, media) {
    const id = item.idInStore || item.itemID;
    this.wishlistService.removeItem(Global.getCountry(), Global.getStore(), Global.getItemTypeForWishList(media),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortWishlist();
    }, res => {

    });
  }

  addToOwnlist(item, media) {
    const id = item.idInStore || item.itemID;
    this.ownlistService.addItem(Global.getCountry(), Global.getStore(), Global.getItemTypeForWishList(media),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortOwnlist();
    }, res => {

    });
  }

  removeFromOwnlist(item, media) {
    const id = item.idInStore || item.itemID;
    this.ownlistService.removeItem(Global.getCountry(), Global.getStore(), Global.getItemTypeForWishList(media),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortOwnlist();
    }, res => {

    });
  }

  addToBlocklist(item, media) {
    const id = item.idInStore || item.itemID;
    this.blocklistService.addItem(Global.getCountry(), Global.getStore(), Global.getItemTypeForWishList(media),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortBlocklist();
    }, res => {

    });
  }

  getShortWishlist() {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);

    if (sessionToken){
      this.wishlistService.getShortWishlist(
        Global.getCountry(),
        Global.getStore(),
        sessionToken
      ).subscribe(res => {
        if (res && res['results']) {
          const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist) || {};
          shortWishlist[Global.getStore()] = res["results"];
          const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortWishlist, shortWishlist);
          if (saved) {
            ListHelper.clearWishlistCache();
          } else {
            Log.getInstance().d('Failed to save wishlist to storage - storage may be full');
          }
        }

      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

  getShortOwnlist() {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);

    if (sessionToken){
      this.ownlistService.getShortItemList(
        sessionToken,
        Global.getStore(),
        Global.getCountry()
      ).subscribe(res => {
        if (res && res['results']) {
          const shortOwnlist = StorageHelper.getInstance().get(StorageHelper.keys.shortOwnlist) || {};
          shortOwnlist[Global.getStore()] = res["results"];
          const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortOwnlist, shortOwnlist);
          if (saved) {
            ListHelper.clearOwnlistCache();
          } else {
            Log.getInstance().d('Failed to save ownlist to storage - storage may be full');
          }
        }

      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

  getShortBlocklist() {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);

    if (sessionToken){
      this.blocklistService.getShortBlocklist(
        Global.getCountry(),
        Global.getStore(),
        sessionToken
      ).subscribe(res => {
        if (res && res['results']) {
          const shortBlocklist = StorageHelper.getInstance().get(StorageHelper.keys.shortBlocklist) || {};
          shortBlocklist[Global.getStore()] = res["results"];
          const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortBlocklist, shortBlocklist);
          if (saved) {
            ListHelper.clearBlocklistCache();
          } else {
            Log.getInstance().d('Failed to save blocklist to storage - storage may be full');
          }
        }

      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

  showAmazonUSItems(): boolean {
    if(Global.getCountry() == "us" && Global.getStore() == Global.AMAZON && !Config.showAmazonUS) {
      return false;
    }
    return true;
  }

}
